import React from "react";

import ThemeContext from "~/common/ThemeContext";
import microsoftTodoSettings from "~/legacy-assets/images/microsoft-todo/microsoft_todo_settings.svg?url";
import microsoftTodoSettingsDark from "~/legacy-assets/images/microsoft-todo/microsoft_todo_settings_dark.svg?url";

import styles from "./MicrosoftTodo.module.css";

export default function AboutMicrosoftTodo() {
	const { isDarkMode } = React.useContext(ThemeContext);

	return (
		<>
			<div className={styles.header}>
				<span className={styles.headerTitle}>About this integration</span>
			</div>
			<div className={styles.settingsText}>
				<p>
					The Microsoft To Do integration helps you streamline the heavy lifting when managing tasks between platforms.
					When a new action item is assigned to you, Fellow automatically creates an identical task within the Microsoft
					To Do list you’ve selected. As you mark items as complete, their state will also update between the two
					platforms.
				</p>
				<ul>
					<li className={styles.listItem}>Select a Microsoft To Do list to stay in sync with. </li>
					<li className={styles.listItem}>
						Automatically create Microsoft To Do tasks from Fellow action items assigned to you.
					</li>
					<li className={styles.listItem}>
						Automatically keep task names, due dates and status in sync between Fellow and Microsoft To Do.
					</li>
				</ul>
			</div>
			<img src={isDarkMode ? microsoftTodoSettingsDark : microsoftTodoSettings} className={styles.settingImage} />
		</>
	);
}
